import React from 'react'
import bg26 from '../../assets/images/background/bg-26.png'
import mainchef from '../../assets/images/resource/mainchef.jpg'

function Chefsection() {
    return (
        <>
            <section className="chef-section">
                <div className="right-bg"><img src={bg26} alt="" title="" /></div>
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div className="inner wow fadeInLeft" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="image"><img src={mainchef} alt="" /></div>
                            </div>
                        </div>

                        <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div className="inner clearfix wow fadeInRight" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="content-box">
                                    <div className="title-box">
                                        <div className="subtitle"><span>15 godina iskustva</span></div>
                                        <div className="pattern-image">
                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                                        </div>
                                        <h2>Kvalitet Koji Garantujemo</h2>
                                        <div className="text">Naš tim posvećenih majstora svakodnevno priprema svako jelo sa pažnjom i ljubavlju. Koristimo samo najsvežije sastojke i držimo se proverenih recepata koji garantuju autentičan ukus. Vaše zadovoljstvo je naša misija.</div>
                                    </div>
                                    <div className="info">
                                        <div className="signature" style={{ fontFamily: "'Great Vibes', cursive", fontSize: "48px", color: "var(--main-color)", marginBottom: "20px" }}>BonAppetit</div>
                                        <div className="author">Bon Appetit Tim - Od 2010</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Chefsection